module.exports = __webpack_public_path__ + "static/img/90-2.b3277fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/90-2.jpg
// module id = Sfp0
// module chunks = 0